import { AnalyzerAction, AnalyzerState } from './PromptAnalyzerModalHelpers';

export const initialAnalyzerState: AnalyzerState = {
  editableText: '',
  issues: [],
  summary: '',
  activeIssueId: null,
  isEditing: false,
  analyzing: false,
  rewriting: false,
  hasAnalyzed: false,
  rewrittenText: '',
  changeSummary: '',
  error: '',
  promptTab: 'original',
  copied: false,
};

export function analyzerReducer(state: AnalyzerState, action: AnalyzerAction): AnalyzerState {
  switch (action.type) {
    case 'RESET':
      return { ...initialAnalyzerState, editableText: action.promptText };

    case 'SET_EDITABLE_TEXT':
      return { ...state, editableText: action.text };

    case 'ANALYZE_START':
      return {
        ...state,
        analyzing: true,
        error: '',
        rewrittenText: '',
        changeSummary: '',
        promptTab: 'original',
      };

    case 'ANALYZE_SUCCESS':
      return {
        ...state,
        analyzing: false,
        issues: action.issues,
        summary: action.summary,
        hasAnalyzed: true,
        isEditing: false,
      };

    case 'ANALYZE_ERROR':
      return { ...state, analyzing: false, error: action.error };

    case 'REWRITE_START':
      return { ...state, rewriting: true, error: '' };

    case 'REWRITE_SUCCESS':
      return {
        ...state,
        rewriting: false,
        rewrittenText: action.optimizedPrompt,
        changeSummary: action.changeSummary,
        promptTab: 'rewritten',
      };

    case 'REWRITE_ERROR':
      return { ...state, rewriting: false, error: action.error };

    case 'ACCEPT_REWRITE':
      return { ...initialAnalyzerState, editableText: action.rewrittenText };

    case 'SET_ACTIVE_ISSUE':
      return { ...state, activeIssueId: action.id };

    case 'SET_PROMPT_TAB':
      return { ...state, promptTab: action.tab };

    case 'TOGGLE_EDIT':
      return { ...state, isEditing: !state.isEditing };

    case 'SET_COPIED':
      return { ...state, copied: action.copied };

    default:
      return state;
  }
}
